import { useState } from 'react';

import { logError } from 'services/logging/logging';

export const useCopyToClipboard = (resetDelay = 2000) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = (text: string) => {
    setIsCopied(true);
    navigator.clipboard.writeText(text).catch((e) => {
      logError(e);
      setIsCopied(false);
    });
    setTimeout(() => {
      setIsCopied(false);
    }, resetDelay);
  };

  return { isCopied, copyToClipboard };
};
